import cn from 'classnames';
import { isString } from '@anton.bobrov/react-hooks';
import { prefixedClassName } from './prefixedClassName';
export function prefixedClasNames() {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    return cn(classNames.map(function (value) {
        return isString(value) ? prefixedClassName(value) : '';
    }));
}
//# sourceMappingURL=prefixedClassNames.js.map